export default __webpack_public_path__ + "static/media/pressure.986a7a9b.svg";